export default "__VITE_ASSET__7141a691__"